import LegalPage from "@/components/LegalPage";

const LAST_UPDATED = "10 de febrero de 2026";

const POLICIES = {
    terms: {
        title: "Términos y condiciones",
        sections: [
            {
                h: "Objeto y aceptación",
                body: [
                    "Estos Términos regulan el uso de la plataforma Play2Win (en adelante, “la Plataforma”). Al registrarte o utilizar la Plataforma aceptas estos Términos en su totalidad.",
                    "Si no estás de acuerdo con alguna cláusula, debes abstenerte de utilizar el servicio.",
                ],
            },
            {
                h: "Descripción del servicio",
                body: [
                    "Play2Win es una plataforma social de predicciones basada en habilidad. Los usuarios compiten entre sí en mercados (pools) y la Plataforma retiene una comisión del bote común. No es una casa de apuestas y no opera bajo modelo de “casa contra el jugador”.",
                    "En el MVP actual la Plataforma funciona exclusivamente con puntos virtuales sin valor monetario. La integración de dinero real, retiros y pasarelas de pago queda sujeta a validación legal por país y se anunciará por separado.",
                ],
            },
            {
                h: "Elegibilidad y mayoría de edad",
                body: [
                    "Para registrarte debes tener al menos 18 años o la mayoría de edad establecida en tu jurisdicción, lo que sea mayor. Te obligas a declarar información verídica.",
                    "Nos reservamos el derecho a verificar identidad y edad (KYC/AML) cuando se habilite el uso con dinero real.",
                ],
            },
            {
                h: "Cuenta y responsabilidades del usuario",
                body: [
                    "Eres responsable de la confidencialidad de tus credenciales y de toda actividad realizada bajo tu cuenta.",
                    "Una persona, una cuenta. Está prohibida la creación de cuentas múltiples (multicuenta) o la cesión de la cuenta a terceros.",
                ],
            },
            {
                h: "Reglas de mercados y liquidación",
                body: [
                    "Cada mercado declara antes de su apertura: pregunta, opciones, fecha de cierre, fuente de resolución y comisión aplicable.",
                    "Los pozos son comunes y se reparten entre los aciertos en proporción a la apuesta, descontando las comisiones de la Plataforma, del creador (si aplica) y de la liga. La matemática de cada liquidación queda registrada en el ledger de movimientos.",
                    "Si una resolución se considera incorrecta, existe una ventana de disputa cuyo plazo se indica en el detalle del mercado.",
                ],
            },
            {
                h: "Conducta prohibida",
                body: [
                    [
                        "Colusión entre usuarios o coordinación para manipular resultados.",
                        "Uso de bots, scripts o automatizaciones no autorizadas.",
                        "Multicuenta, suplantación de identidad o uso de datos falsos.",
                        "Abuso de bonos, referidos o promociones.",
                        "Cualquier actividad contraria a la ley aplicable.",
                    ],
                ],
            },
            {
                h: "Propiedad intelectual",
                body: [
                    "Todos los contenidos, marcas, logotipos y software de la Plataforma son propiedad de Play2Win o de sus licenciantes. No se concede más licencia que el uso personal previsto en estos Términos.",
                ],
            },
            {
                h: "Limitación de responsabilidad",
                body: [
                    "La Plataforma se presta “tal cual”. En la máxima medida permitida por la ley, Play2Win no responde por lucro cesante, pérdida de datos o daños indirectos derivados del uso del servicio.",
                    "Las predicciones son decisiones del usuario; no garantizamos ganancias ni resultados.",
                ],
            },
            {
                h: "Modificaciones",
                body: [
                    "Podemos actualizar estos Términos. Te notificaremos cuando haya cambios materiales y, si continúas usando la Plataforma, se entenderá que aceptas la nueva versión.",
                ],
            },
            {
                h: "Ley aplicable y contacto",
                body: [
                    "Estos Términos se rigen por la legislación del país en el que opera la entidad responsable de Play2Win, sin perjuicio de los derechos imperativos del consumidor.",
                    "Para cualquier consulta legal escríbenos a legal@play2win.com.",
                ],
            },
        ],
    },

    privacy: {
        title: "Política de privacidad",
        sections: [
            {
                h: "Responsable del tratamiento",
                body: [
                    "Play2Win es responsable del tratamiento de tus datos personales. Para ejercer tus derechos o consultar sobre privacidad, escríbenos a privacidad@play2win.com.",
                ],
            },
            {
                h: "Datos que recogemos",
                body: [
                    [
                        "Datos de cuenta: email, nombre de usuario, avatar opcional, contraseña (hash).",
                        "Datos de actividad: predicciones, movimientos en el ledger, niveles y XP.",
                        "Datos técnicos: dirección IP, identificador de dispositivo, eventos de uso.",
                        "Datos opcionales aportados por ti: enlaces sociales, biografía si aplicas a creador.",
                    ],
                ],
            },
            {
                h: "Finalidades y base legal",
                body: [
                    [
                        "Prestación del servicio y ejecución del contrato (Términos): autenticación, mercados, ledger, soporte.",
                        "Cumplimiento de obligaciones legales: prevención de fraude, AML cuando aplique.",
                        "Interés legítimo: mejora del producto, métricas agregadas, seguridad.",
                        "Consentimiento: cookies analíticas, comunicaciones promocionales.",
                    ],
                ],
            },
            {
                h: "Encargados y terceros",
                body: [
                    "Para operar la Plataforma utilizamos encargados de tratamiento que actúan bajo nuestras instrucciones, incluyendo proveedores de hosting, autenticación, base de datos y analítica. Sus accesos están limitados a lo estrictamente necesario.",
                    "No vendemos tus datos personales a terceros.",
                ],
            },
            {
                h: "Conservación",
                body: [
                    "Conservamos tus datos mientras tengas cuenta activa y durante los plazos legales aplicables tras su cierre, por motivos contables, fiscales y de prevención de fraude.",
                ],
            },
            {
                h: "Derechos del usuario",
                body: [
                    "Puedes ejercer en cualquier momento tus derechos de acceso, rectificación, supresión, oposición, limitación y portabilidad, así como retirar el consentimiento cuando aplique.",
                    "Para ejercerlos escribe a privacidad@play2win.com indicando el derecho que deseas ejercer. También puedes presentar reclamación ante la autoridad de control competente.",
                ],
            },
            {
                h: "Transferencias internacionales",
                body: [
                    "Cuando un proveedor opere fuera del Espacio Económico Europeo (u otra región aplicable), exigimos garantías adecuadas (cláusulas contractuales tipo, certificaciones reconocidas) para proteger tus datos.",
                ],
            },
            {
                h: "Seguridad",
                body: [
                    "Aplicamos medidas técnicas y organizativas razonables: cifrado en tránsito, hash de contraseñas, control de accesos, monitorización y registro de auditoría.",
                ],
            },
            {
                h: "Menores",
                body: [
                    "La Plataforma no está dirigida a menores de edad. Si detectamos un registro de menor, procederemos al cierre de la cuenta.",
                ],
            },
        ],
    },

    cookies: {
        title: "Política de cookies",
        sections: [
            {
                h: "Qué son las cookies",
                body: [
                    "Las cookies son pequeños archivos que se almacenan en tu dispositivo cuando visitas un sitio web. Sirven para recordar tus preferencias, mantener tu sesión y medir el uso de la plataforma.",
                ],
            },
            {
                h: "Tipos de cookies que usamos",
                body: [
                    [
                        "Esenciales: necesarias para que la Plataforma funcione (sesión, autenticación, seguridad). No se pueden desactivar.",
                        "Preferencias: recuerdan idioma, tema y otras opciones del usuario.",
                        "Analíticas: nos ayudan a entender de forma agregada cómo se usa la Plataforma para mejorarla.",
                    ],
                ],
            },
            {
                h: "Consentimiento",
                body: [
                    "Al entrar por primera vez verás un banner para aceptar todas las cookies o rechazar las no esenciales. Tu elección se guarda localmente y se respeta en visitas posteriores hasta que la cambies.",
                ],
            },
            {
                h: "Cómo gestionar o desactivar cookies",
                body: [
                    "Puedes borrar las cookies almacenadas o bloquearlas desde la configuración de tu navegador. Si las bloqueas por completo, partes de la Plataforma podrían no funcionar correctamente.",
                ],
            },
            {
                h: "Lista de cookies principales",
                body: [
                    [
                        "p2w-cookie-consent-v1: guarda tu elección sobre el banner de cookies.",
                        "p2w-auth-token: mantiene tu sesión iniciada (esencial).",
                        "p2w-i18n: recuerda el idioma seleccionado.",
                    ],
                ],
            },
            {
                h: "Cambios en esta política",
                body: [
                    "Podemos actualizar la política de cookies. Si los cambios son materiales te lo indicaremos en el banner para que vuelvas a expresar tu preferencia.",
                ],
            },
        ],
    },

    responsible: {
        title: "Juego responsable",
        sections: [
            {
                h: "Nuestro compromiso",
                body: [
                    "Play2Win se compromete con un juego sano, social y basado en habilidad. En el MVP actual no se opera con dinero real: la experiencia funciona únicamente con puntos virtuales sin valor monetario.",
                ],
            },
            {
                h: "Habilidad, no azar",
                body: [
                    "Nuestro modelo recompensa la capacidad de analizar información, no la suerte. Aun así, ninguna predicción es segura; tus decisiones deben ser informadas y proporcionales.",
                ],
            },
            {
                h: "Cómo jugar de forma saludable",
                body: [
                    [
                        "Fija un límite de tiempo y de puntos antes de cada sesión.",
                        "No persigas pérdidas: jugar para “recuperar” suele empeorar la situación.",
                        "Equilibra Play2Win con otras actividades; no dejes que sustituya tu vida social u obligaciones.",
                        "Pide ayuda si notas que pierdes el control.",
                    ],
                ],
            },
            {
                h: "Soporte y autoexclusión",
                body: [
                    "Cuando se habilite el dinero real implementaremos límites de depósito, alertas de actividad y autoexclusión voluntaria. Hasta entonces, puedes solicitar la pausa o el cierre de tu cuenta escribiéndonos a soporte@play2win.com.",
                ],
            },
            {
                h: "Recursos de ayuda",
                body: [
                    "Si crees que tu relación con el juego está afectándote o afectando a alguien cercano, busca ayuda profesional. En la mayoría de países existen líneas de atención especializadas en ludopatía.",
                ],
            },
        ],
    },

    antifraude: {
        title: "Política AML / Antifraude",
        sections: [
            {
                h: "Compromiso de integridad",
                body: [
                    "Play2Win está comprometido con la integridad de la competencia y con la prevención del fraude, el blanqueo de capitales y la financiación de actividades ilícitas. Esta política aplica a todos los usuarios y creadores.",
                ],
            },
            {
                h: "Conductas prohibidas",
                body: [
                    [
                        "Multicuenta: crear más de una cuenta por persona o utilizar identidades falsas.",
                        "Colusión: coordinarse con otros usuarios para manipular pozos, cuotas o resultados.",
                        "Manipulación de resultados o de fuentes de resolución.",
                        "Uso de bots, scripts u otras automatizaciones no autorizadas.",
                        "Abuso de bonos, referidos, promociones o programas de creadores.",
                        "Cualquier conducta orientada al lavado de activos o a ocultar el origen de los fondos.",
                    ],
                ],
            },
            {
                h: "Medidas de detección y verificación",
                body: [
                    "Aplicamos controles automáticos y manuales: análisis de patrones de actividad, dispositivos, IPs, redes de referidos y consistencia del histórico.",
                    "Cuando se habilite el dinero real exigiremos verificación de identidad (KYC) y verificación reforzada (EDD) en casos de riesgo, conforme a la normativa AML aplicable.",
                ],
            },
            {
                h: "Consecuencias",
                body: [
                    [
                        "Suspensión temporal o cierre definitivo de la cuenta.",
                        "Retención y reversión de puntos o, en su momento, fondos asociados a la conducta detectada.",
                        "Inhabilitación para participar en mercados, programa de creadores y rankings.",
                        "Reporte a las autoridades competentes cuando exista indicio de delito.",
                    ],
                ],
            },
            {
                h: "Cómo reportar fraude",
                body: [
                    "Si detectas una conducta sospechosa, escríbenos a fraude@play2win.com con la mayor cantidad de detalles posible (usuarios implicados, mercados, fechas). Las denuncias son tratadas con confidencialidad.",
                ],
            },
        ],
    },

    creators_terms: {
        title: "Términos para creadores",
        sections: [
            {
                h: "Aceptación del programa",
                body: [
                    "Al ser admitido como creador en Play2Win aceptas estos Términos específicos, además de los Términos generales y las políticas de Juego responsable, Privacidad y AML/Antifraude.",
                ],
            },
            {
                h: "Compromisos del creador",
                body: [
                    [
                        "Crear mercados claros, con pregunta, opciones y fuente de resolución verificable declaradas antes de su apertura.",
                        "No prometer “dinero fácil”, ganancias seguras ni inducir a error a la audiencia.",
                        "Resolver los mercados conforme a la fuente declarada y dentro de los plazos previstos.",
                        "Mantener un trato respetuoso con la comunidad: no acoso, no discriminación, no spam.",
                    ],
                ],
            },
            {
                h: "Comisiones",
                body: [
                    "Los creadores reciben una comisión por cada pozo resuelto en sus mercados, en función de su tier (Bronze 5%, Silver 6%, Gold 7%) y siempre por debajo del total del pozo. La comisión queda reflejada en el ledger del creador.",
                    "La Plataforma puede ajustar los porcentajes y criterios de tier; los cambios se notificarán con antelación razonable.",
                ],
            },
            {
                h: "Suspensión y baja",
                body: [
                    "Podemos suspender o dar de baja a un creador que incumpla estos Términos, abuse del programa o reciba reportes fundados. Durante la suspensión no podrá crear nuevos mercados ni cobrar comisiones.",
                ],
            },
            {
                h: "Contenido y propiedad intelectual",
                body: [
                    "El creador es responsable del contenido que publica y declara contar con los derechos para hacerlo. Otorga a Play2Win una licencia no exclusiva para mostrar dicho contenido dentro de la Plataforma.",
                ],
            },
            {
                h: "Cambios en el programa",
                body: [
                    "El programa de creadores puede evolucionar. Comunicaremos los cambios materiales y, en su caso, requeriremos una nueva aceptación de estos Términos.",
                ],
            },
        ],
    },
};

export default function Legal({ kind }) {
    const policy = POLICIES[kind];
    if (!policy) {
        return (
            <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
                <h1 className="font-sora font-extrabold text-3xl">Página legal no encontrada</h1>
            </div>
        );
    }
    return (
        <LegalPage
            kind={kind}
            title={policy.title}
            lastUpdated={LAST_UPDATED}
            sections={policy.sections}
            pendingReview
        />
    );
}
